import { Trans, useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'

import { useToolBoxTreatments } from '@/common/hooks'
import { LIBELLULA_PRICING_REDIRECT_URL, TOOLBOX_PRICING_REDIRECT_URL } from '@/common/utils'

const UpgradePlanLink = () => {
    const { t } = useTranslation()
    const { showLibellulaWhitelabelling } = useToolBoxTreatments()

    const linkHref = showLibellulaWhitelabelling ? LIBELLULA_PRICING_REDIRECT_URL : TOOLBOX_PRICING_REDIRECT_URL

    return (
        <Trans t={t}>
            The plan you are subscribed to does not include this feature. Please{' '}
            <Link
                component={RouterLink}
                to={linkHref}
            >
                upgrade
            </Link>{' '}
            your plan.
        </Trans>
    )
}

export default UpgradePlanLink
